import { useBreakpoints } from "../../utils/use-breakpoints"
import { Flex, Group, GroupProps } from "@mantine/core"
import { SuspenseWithErrorBoundary } from "../suspense"
import { NavGroup, NavGroupProps } from "../NavGroup"
import { ScrollContainer } from "../scroll-container"
import { DottedMenu, DottedMenuProps } from "../dotted-menu"
import { forwardRef } from "react"
import { useLocation } from "@tanstack/react-router"
import { useShowReminderIcon } from "./use-show-reminder-icon"

interface Props
  extends React.PropsWithChildren,
    Pick<NavGroupProps, "crumbOverride"> {
  buttonGroupProps?: GroupProps
  dottedMenuProps?: DottedMenuProps
  navGroupProps?: GroupProps
  infoDescription?: string
  titleGroupProps?: GroupProps
  crumbOverride?: () => React.ReactElement
}

export const Page = forwardRef<HTMLDivElement, Props>(
  (
    {
      children,
      buttonGroupProps,
      crumbOverride,
      dottedMenuProps,
      titleGroupProps,
      navGroupProps,
    },
    ref
  ) => {
    const { xs, sm } = useBreakpoints()
    const location = useLocation().pathname
    const path = location.split("?")[0]
    const showReminderIcon = useShowReminderIcon(path)

    return (
      <Flex mah="100%" h="100%" direction="column" ref={ref}>
        <Group
          justify="space-between"
          align="center"
          wrap="nowrap"
          px={sm || xs ? "sm" : "md"}
          py="md"
          h={xs || sm ? undefined : "60px"}
          {...titleGroupProps}
        >
          <NavGroup crumbOverride={crumbOverride} {...navGroupProps} />
          <Group>
            {buttonGroupProps ? <Group {...buttonGroupProps} /> : null}
            {dottedMenuProps &&
            dottedMenuProps.items &&
            dottedMenuProps.items.filter((item) => item !== null).length > 0 ? (
              <DottedMenu {...dottedMenuProps} />
            ) : null}
          </Group>
        </Group>

        <ScrollContainer
          px={sm || xs ? "sm" : "md"}
          mb="md"
          direction="column"
          flex={1}
        >
          <SuspenseWithErrorBoundary>{children}</SuspenseWithErrorBoundary>
        </ScrollContainer>
      </Flex>
    )
  }
)
